import apiClient from './apiClient';

/**
 * AdminService - Admin-specific operations like broadcasts and user management
 */

interface BroadcastMessagePayload {
  subject: string;
  message: string;
  target_audience: 'all' | 'clients' | 'artisans';
}

interface CreateAdminUserPayload {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  password: string;
  role: 'moderator' | 'admin';
}

interface BroadcastMessageResponse {
  message_id: string;
  recipients_count: number;
  sent_at: string;
}

interface CreateAdminUserResponse {
  user_id: string;
  email: string;
  role: string;
  created_at: string;
}

class AdminService {
  /**
   * Send a broadcast message to users
   *
   * POST /api/admin/broadcast-message/
   */
  async broadcastMessage(
    data: BroadcastMessagePayload
  ): Promise<BroadcastMessageResponse> {
    try {
      const response = await apiClient.post('/admin/broadcast-message/', {
        subject: data.subject,
        message: data.message,
        target_audience: data.target_audience,
      });
      return response.data.data;
    } catch (error: any) {
      console.error('❌ Error sending broadcast message:', error.response?.data || error.message);
      throw error;
    }
  }

  /**
   * Create a new admin or moderator user
   *
   * POST /api/admin/users/create-admin/
   */
  async createAdminUser(
    data: CreateAdminUserPayload
  ): Promise<CreateAdminUserResponse> {
    try {
      const response = await apiClient.post('/admin/users/create-admin/', {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone_number: data.phone_number,
        password: data.password,
        role: data.role,
      });
      return response.data.data;
    } catch (error: any) {
      console.error('❌ Error creating admin user:', error.response?.data || error.message);
      throw error;
    }
  }
}

export default new AdminService();
